import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface SubscriptionState {
  initialized: boolean;
  subscriptions: any[];
}

const initialState: SubscriptionState = {
  initialized: false,
  subscriptions: [],
};

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setInitialized: (state, action: PayloadAction<boolean>) => {
      state.initialized = action.payload;
    },
    setSubscriptions: (state, action: PayloadAction<any[]>) => {
      state.subscriptions = action.payload;
    },
  },
});

export const { setSubscriptions, setInitialized } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
